<ion-content class="ion-padding">
  <div class="modal-content">
    <smatchy-title mode="end">{{ 'NOTIFICATION_MODALE.TITLE' | translate }}</smatchy-title>

    <div class="w-60 m-auto flex flex-col gap-6">
      <div class="bg-[#FCA13B26] rounded-full w-[80px] h-[80px] flex flex-col justify-center items-center m-auto">
        <smatchy-icon class="text-[#ffaa00] flex" [icon]="'bell'" size="medium" color="#ffaa00"></smatchy-icon>
      </div>

      <p class="font-medium">
        {{ 'NOTIFICATION_MODALE.DESCRIPTION' | translate }}
      </p>
    </div>

    <div class="flex flex-col gap-3">
      <ion-button expand="block" (click)="enableNotifications()">{{
        'NOTIFICATION_MODALE.BTN_TITLE' | translate
      }}</ion-button>
      <ion-button expand="block" fill="outline" (click)="dismiss()">{{
        'NOTIFICATION_MODALE.LATER' | translate
      }}</ion-button>
    </div>
  </div>
</ion-content>
